export const dict = {
  nl: {
    // nav
    nav_shop: "Catalogus",
    nav_about: "Over ons",
    nav_faq: "Vragen",
    nav_contact: "Contact",
    nav_account: "Account",
    nav_login: "Inloggen",
    nav_logout: "Uitloggen",
    nav_cart: "Winkelmand",
    // common
    ui_loading: "Laden…",
    ui_verified_purchase: "Geverifieerde aankoop",
    ui_in_stock: "Op voorraad · verzend vandaag",
    ui_low_stock: "Nog {n} op voorraad",
    ui_very_low_stock: "Nog maar {n} op voorraad",
    ui_bulk_active: "{pct}% bulkkorting actief",
    // hero urgency
    hero_urgency: "Voor 15:00 besteld = vandaag verzonden",
    // dispatch countdown
    countdown_before: "Verzonden vandaag als je bestelt binnen",
    countdown_after: "Volgende zending in",
    // order now section
    order_live_badge: "LIVE · VANDAAG NOG VERZONDEN",
    order_before: "Voor 15:00 CET",
    order_bullet_free_ship: "Gratis verzending > €200",
    order_bullet_hplc: "HPLC ≥ 99% zuiverheid",
    order_bullet_stripe: "Betaal veilig via Stripe",
    order_bullet_discreet: "Discreet verpakt",
    // countdown box labels
    // cart
    cart_fill_name_email: "Vul naam en e-mail in",
    cart_accept_terms: "Accepteer alle vereiste verklaringen",
    cart_check_terms: "Vink verklaringen aan",
    cart_confirm_order: "Bevestig bestelling →",
    cart_payment_method: "BETAALMETHODE",
    cart_pm_bank: "Bankoverschrijving",
    cart_pm_bank_desc: "iDEAL · Bunq · SEPA · handmatig overmaken via je bank app. Werkt vandaag al.",
    cart_pm_stripe: "Direct betalen (Stripe)",
    cart_pm_stripe_desc: "Creditcard, PayPal, Klarna. Volgt na Stripe activatie.",
    cart_secure_line: "Veilig · SSL · GDPR compliant",
    cart_payment_failed: "Betaling mislukt",
    cart_shipping_addr: "VERZENDADRES",
    cart_summary: "SAMENVATTING",
    cart_free_ship_remaining: "Nog €{amount} voor gratis verzending",
    cart_free_ship_unlocked: "✓ Gratis verzending vrijgespeeld",
    cart_calculated_next: "BEREKEND IN VOLGENDE STAP",
    cart_free: "GRATIS",
    // product page
    pdp_price: "Prijs",
    pdp_per_unit: "~€{n} per {unit}",
    pdp_bundle_badge: "BUNDLE · 20% KORTING",
    pdp_bundle_needed: "Nodig voor reconstitutie",
    pdp_bundle_add: "Voeg BAC Water 10ml toe",
    pdp_bundle_desc: "— noodzakelijk om {name} op te lossen",
    pdp_added: "{name} toegevoegd",
    pdp_added_bundle: "{name} + BAC Water toegevoegd",
    pdp_disclaimer_label: "DISCLAIMER",
    pdp_regular: "Regulier",
    pdp_tier_1: "1–2 stuks",
    pdp_tier_2: "3–4 stuks",
    pdp_tier_3: "5+ stuks",
    // bank instructions
    bank_title: "Bijna klaar.",
    bank_sub: "Maak het bedrag over — dan versturen we binnen 24u.",
    bank_to_pay: "TE BETALEN",
    bank_payment_info: "BETAALGEGEVENS",
    bank_amount: "Bedrag",
    bank_iban: "IBAN",
    bank_bic: "BIC",
    bank_holder: "Ten name van",
    bank_reference: "Kenmerk *",
    bank_reference_note: "* Vermeld altijd dit kenmerk bij de overschrijving — zodat we jouw bestelling kunnen matchen.",
    bank_your_order: "JOUW BESTELLING",
    bank_total: "Totaal",
    bank_step_1_t: "Maak over",
    bank_step_1_b: "Open je bank app (iDEAL / Bunq / SEPA) en betaal via IBAN + kenmerk.",
    bank_step_2_t: "Wij checken",
    bank_step_2_b: "Zodra we de betaling zien, krijg je een bevestigings-e-mail.",
    bank_step_3_t: "Verzending 24u",
    bank_step_3_b: "Bestelling wordt discreet verzonden vanuit Nederland.",
    bank_continue: "Verder winkelen",
    bank_mail_us: "Vraag? Mail ons →",
    bank_email_sent_to: "Je ontvangt de instructies ook per e-mail op {email}",
    bank_copy: "KOPIEER",
    bank_copied: "GEKOPIEERD ✓",
    bank_ref_copied: "Kenmerk gekopieerd",
    bank_not_found_label: "ORDER NIET GEVONDEN",
    bank_not_found_title: "Kenmerk onbekend",
    bank_back_shop: "Terug naar shop",
    // reviews widget & section
    reviews_widget_over: "SOCIAL PROOF · REVIEWS",
    reviews_widget_title_l1: "Vertrouwd door",
    reviews_widget_title_l2: "onderzoekers",
    reviews_widget_title_l3: "in heel Europa.",
    reviews_widget_stat_reviews: "reviews · geverifieerde aankopen",
    reviews_widget_repeat: "Herhaal-aankopen",
    reviews_widget_support: "Support respons",
    reviews_widget_cta_line: "Wil je jouw ervaring delen?",
    reviews_widget_cta_link: "Bekijk producten",
    reviews_widget_cta_end: "en laat een review achter na aankoop.",
    reviews_widget_cta_btn: "Bestel & review →",
    reviews_section_title: "Wat onderzoekers zeggen",
    reviews_section_based_on: "Op basis van {n} reviews",
    reviews_write: "Schrijf review",
    reviews_close: "Sluiten",
    reviews_new_review: "NIEUWE REVIEW",
    reviews_rating: "Beoordeling:",
    reviews_name: "Naam",
    reviews_title_field: "Titel",
    reviews_body: "Je ervaring…",
    reviews_submit: "Plaats review →",
    reviews_thanks: "Review geplaatst — bedankt!",
    reviews_none: "Nog geen reviews. Wees de eerste!",
    reviews_fill_all: "Vul alle velden in",
    // social proof toast
    toast_recently_ordered: "RECENTLY ORDERED",
    toast_min_ago: "{n}m geleden",
    // hero
    hero_overline: "Peptivance — Onderzoekskwaliteit",
    hero_l1: "Peptivance.",
    hero_l2: "99.4% HPLC.",
    hero_l3: "Vandaag verzonden.",
    hero_l4: "Onmiskenbaar puur.",
    hero_sub: "Vertrouwd door 500+ Europese onderzoekslabs. Bestel vóór 15:00 — vandaag nog verzonden vanuit Nederland, getrackt en discreet. Geen tussenhandel, geen shortcuts — alleen research grade peptiden waar je resultaten op kunt bouwen.",
    hero_cta_shop: "Nu bestellen",
    hero_cta_about: "Zie kwaliteitsrapport",
    // hero social proof
    hero_stat_reviews: "13 reviews",
    hero_stat_rating: "4.9/5",
    hero_stat_purity: "99.4%",
    hero_stat_purity_label: "HPLC-gevalideerd",
    hero_stat_dispatch: "24u",
    hero_stat_dispatch_label: "verzending NL",
    hero_stat_customers: "500+",
    hero_stat_customers_label: "onderzoekers",
    // marquee
    marquee: "Research grade . Lyophilized . Third-party tested . Not for human consumption",
    // chapters
    chapter_label: "Hoofdstuk",
    // order now section
    order_now_over: "Bestel nu",
    order_now_title_1: "Vandaag besteld.",
    order_now_title_2: "Morgen in je lab.",
    order_now_sub: "Voor 15:00 besteld — vandaag nog verzonden vanuit Nederland. Getrackt, temperatuur-gecontroleerd en discreet verpakt.",
    order_now_cta: "Direct bestellen",
    order_now_bullet_1: "24u verzending NL",
    order_now_bullet_2: "Third-party COA",
    order_now_bullet_3: "Discrete verpakking",
    order_now_bullet_4: "Veilige betaling",
    // sections
    sec_catalog_over: "Catalogus",
    sec_catalog_title: "De complete onderzoeksuitrusting. Eén standaard.",
    sec_catalog_sub: "Elke flacon is genummerd, verzegeld en third-party geanalyseerd. Prijzen inclusief BTW.",
    view_product: "Bekijk product",
    add_to_cart: "In winkelmand",
    // manifesto
    manifesto_over: "Manifest",
    manifesto_title: "Wat wij onder onderzoekskwaliteit verstaan.",
    m1_t: "Aseptische productie",
    m1_b: "Elke batch wordt verpakt onder ISO Class 5 laminar-flow condities. Geen uitzonderingen, geen shortcuts.",
    m2_t: "Third-party validatie",
    m2_b: "HPLC en massaspectrometrie door onafhankelijke Europese laboratoria — rapport bij iedere batch beschikbaar.",
    m3_t: "Transparante herkomst",
    m3_b: "Grondstoffen uit gecertificeerde GMP-faciliteiten. Volledige chain of custody, gedocumenteerd per lot.",
    m4_t: "Snelle EU-verzending",
    m4_b: "Verzonden vanuit Nederland binnen 24 uur. Getrackt, temperatuur-gecontroleerd, discreet verpakt.",
    // ship
    ship_over: "Verzending",
    ship_title: "Van laboratorium tot bureau — koel, gevolgd, discreet.",
    // legal
    legal_disclaimer: "Uitsluitend voor onderzoek. Niet voor menselijke consumptie.",
    // footer
    footer_tag: "Onderzoekskwaliteit peptiden. Verzonden vanuit Nederland.",
    footer_navigate: "Navigatie",
    footer_legal: "Juridisch",
    footer_disclaimer: "Onderzoeksdisclaimer",
    footer_terms: "Voorwaarden",
    footer_privacy: "Privacy",
    // cart
    cart_title: "Winkelmand",
    cart_empty: "Je winkelmand is leeg.",
    cart_continue: "Verder winkelen",
    cart_subtotal: "Subtotaal",
    cart_shipping: "Verzending",
    cart_total: "Totaal",
    cart_checkout: "Naar betalen",
    // checkout success
    success_title: "Betaling ontvangen.",
    success_sub: "Bedankt voor je bestelling. Je bestelling wordt binnen 24 uur verzonden.",
    checking: "Betalingsstatus controleren…",
    // auth
    auth_login_title: "Inloggen",
    auth_register_title: "Registreren",
    auth_email: "E-mailadres",
    auth_password: "Wachtwoord",
    auth_name: "Naam",
    auth_no_account: "Nog geen account?",
    auth_have_account: "Al een account?",
    auth_register_link: "Registreer",
    auth_login_link: "Inloggen",
    auth_submit_login: "Inloggen",
    auth_submit_register: "Aanmaken",
    // account
    account_title: "Mijn account",
    account_orders: "Bestellingen",
    account_hello: "Welkom terug",
    // admin
    admin_title: "Beheer",
    admin_products: "Producten",
    admin_orders: "Bestellingen",
    admin_stats: "Statistieken",
    // contact
    contact_title: "Contact",
    contact_sent: "Bericht verzonden. We reageren binnen 24 uur.",
    // faq
    faq_title: "Veelgestelde vragen",
    // disclaimer page
    disclaimer_title: "Onderzoeksdisclaimer",
  },
  en: {
    nav_shop: "Catalogue",
    nav_about: "About",
    nav_faq: "FAQ",
    nav_contact: "Contact",
    nav_account: "Account",
    nav_login: "Sign in",
    nav_logout: "Sign out",
    nav_cart: "Cart",
    hero_overline: "Peptivance — Research grade",
    hero_l1: "Peptivance.",
    hero_l2: "99.4% HPLC.",
    hero_l3: "Shipped today.",
    hero_l4: "Unmistakably pure.",
    hero_sub: "Trusted by 500+ European research labs. Order before 3PM CET — shipped from the Netherlands the same day, tracked and discreet. No middlemen, no shortcuts — research grade peptides you can build results on.",
    hero_cta_shop: "Order now",
    hero_cta_about: "See quality report",
    hero_stat_reviews: "13 reviews",
    hero_stat_rating: "4.9/5",
    hero_stat_purity: "99.4%",
    hero_stat_purity_label: "HPLC validated",
    hero_stat_dispatch: "24h",
    hero_stat_dispatch_label: "NL dispatch",
    hero_stat_customers: "500+",
    hero_stat_customers_label: "researchers",
    hero_urgency: "Order by 3PM = ships today",
    marquee: "Research grade . Lyophilized . Third-party tested . Not for human consumption",
    chapter_label: "Chapter",
    order_now_over: "Order now",
    order_now_title_1: "Order today.",
    order_now_title_2: "In your lab tomorrow.",
    order_now_sub: "Order before 3PM — dispatched same day from the Netherlands. Tracked, temperature-controlled and discreetly packaged.",
    order_now_cta: "Order directly",
    order_now_bullet_1: "24h dispatch NL",
    order_now_bullet_2: "Third-party COA",
    order_now_bullet_3: "Discreet packaging",
    order_now_bullet_4: "Secure payment",
    sec_catalog_over: "Catalogue",
    sec_catalog_title: "The complete research kit. One standard.",
    sec_catalog_sub: "Every vial is serialized, sealed, and third-party analyzed. Prices including VAT.",
    view_product: "View product",
    add_to_cart: "Add to cart",
    manifesto_over: "Manifesto",
    manifesto_title: "What research grade means to us.",
    m1_t: "Aseptic production",
    m1_b: "Every batch is packaged under ISO Class 5 laminar flow conditions. No exceptions, no shortcuts.",
    m2_t: "Third-party validation",
    m2_b: "HPLC and mass spectrometry by independent European laboratories — report available for every batch.",
    m3_t: "Transparent origin",
    m3_b: "Raw materials from certified GMP facilities. Full chain of custody, documented per lot.",
    m4_t: "Fast EU shipping",
    m4_b: "Dispatched from the Netherlands within 24 hours. Tracked, temperature-controlled, discreetly packaged.",
    ship_over: "Fulfilment",
    ship_title: "From laboratory to desk — cold, tracked, discreet.",
    legal_disclaimer: "For research use only. Not for human consumption.",
    footer_tag: "Research grade peptides. Shipped from the Netherlands.",
    footer_navigate: "Navigate",
    footer_legal: "Legal",
    footer_disclaimer: "Research disclaimer",
    footer_terms: "Terms",
    footer_privacy: "Privacy",
    cart_title: "Cart",
    cart_empty: "Your cart is empty.",
    cart_continue: "Continue shopping",
    cart_subtotal: "Subtotal",
    cart_shipping: "Shipping",
    cart_total: "Total",
    cart_checkout: "Proceed to payment",
    success_title: "Payment received.",
    success_sub: "Thank you for your order. It will ship within 24 hours.",
    checking: "Checking payment status…",
    auth_login_title: "Sign in",
    auth_register_title: "Register",
    auth_email: "Email",
    auth_password: "Password",
    auth_name: "Name",
    auth_no_account: "No account yet?",
    auth_have_account: "Already have an account?",
    auth_register_link: "Register",
    auth_login_link: "Sign in",
    auth_submit_login: "Sign in",
    auth_submit_register: "Create account",
    account_title: "My account",
    account_orders: "Orders",
    account_hello: "Welcome back",
    admin_title: "Admin",
    admin_products: "Products",
    admin_orders: "Orders",
    admin_stats: "Stats",
    contact_title: "Contact",
    contact_sent: "Message sent. We respond within 24 hours.",
    faq_title: "Frequently asked questions",
    disclaimer_title: "Research disclaimer",
  },
  de: {
    // nav
    nav_shop: "Katalog",
    nav_about: "Über uns",
    nav_faq: "FAQ",
    nav_contact: "Kontakt",
    nav_account: "Konto",
    nav_login: "Anmelden",
    nav_logout: "Abmelden",
    nav_cart: "Warenkorb",
    // hero
    hero_overline: "Peptivance — Forschungsqualität",
    hero_l1: "Peptivance.",
    hero_l2: "99.4% HPLC.",
    hero_l3: "Heute versandt.",
    hero_l4: "Unverkennbar rein.",
    hero_sub: "Vertraut von über 500 europäischen Forschungslaboren. Bestellen Sie bis 15:00 Uhr — heute noch aus den Niederlanden versandt, getrackt und diskret. Keine Zwischenhändler, keine Abkürzungen — Peptide in Forschungsqualität, auf die Sie Ergebnisse aufbauen können.",
    hero_cta_shop: "Jetzt bestellen",
    hero_cta_about: "Qualitätsbericht ansehen",
    hero_stat_reviews: "13 Bewertungen",
    hero_stat_rating: "4.9/5",
    hero_stat_purity: "99.4%",
    hero_stat_purity_label: "HPLC validiert",
    hero_stat_dispatch: "24h",
    hero_stat_dispatch_label: "Versand NL",
    hero_stat_customers: "500+",
    hero_stat_customers_label: "Forscher",
    hero_urgency: "Bis 15:00 bestellt = heute versandt",
    // marquee
    marquee: "Research grade . Lyophilized . Third-party tested . Not for human consumption",
    chapter_label: "Kapitel",
    // order now section
    order_now_over: "Jetzt bestellen",
    order_now_title_1: "Heute bestellt.",
    order_now_title_2: "Morgen in Ihrem Labor.",
    order_now_sub: "Bis 15:00 Uhr bestellt — heute noch aus den Niederlanden versendet. Getrackt, temperaturkontrolliert und diskret verpackt.",
    order_now_cta: "Direkt bestellen",
    order_now_bullet_1: "24h Versand NL",
    order_now_bullet_2: "Analysezertifikat auf Anfrage",
    order_now_bullet_3: "Diskrete Verpackung",
    order_now_bullet_4: "Sichere Zahlung",
    // sections
    sec_catalog_over: "Katalog",
    sec_catalog_title: "Die komplette Forschungsausrüstung. Ein Standard.",
    sec_catalog_sub: "Jede Fläschchen ist nummeriert, versiegelt und von Drittanbietern analysiert. Preise inklusive MwSt.",
    view_product: "Produkt ansehen",
    add_to_cart: "In den Warenkorb",
    // manifesto
    manifesto_over: "Manifest",
    manifesto_title: "Was Forschungsqualität für uns bedeutet.",
    m1_t: "Aseptische Produktion",
    m1_b: "Jede Charge wird unter ISO Class 5 Laminar-Flow-Bedingungen verpackt. Keine Ausnahmen, keine Abkürzungen.",
    m2_t: "Drittanbieter-Validierung",
    m2_b: "HPLC und Massenspektrometrie von unabhängigen europäischen Laboren — Bericht für jede Charge verfügbar.",
    m3_t: "Transparente Herkunft",
    m3_b: "Rohstoffe aus zertifizierten GMP-Einrichtungen. Vollständige Chain of Custody, pro Charge dokumentiert.",
    m4_t: "Schneller EU-Versand",
    m4_b: "Innerhalb von 24 Stunden aus den Niederlanden versendet. Getrackt, temperaturkontrolliert, diskret verpackt.",
    // legal
    legal_disclaimer: "Nur für Forschungszwecke. Nicht für den menschlichen Verzehr.",
    // footer
    footer_tag: "Peptide in Forschungsqualität. Versand aus den Niederlanden.",
    footer_navigate: "Navigation",
    footer_legal: "Rechtliches",
    footer_disclaimer: "Forschungsdisclaimer",
    footer_terms: "AGB",
    footer_privacy: "Datenschutz",
    // cart
    cart_title: "Warenkorb",
    cart_empty: "Ihr Warenkorb ist leer.",
    cart_continue: "Weiter einkaufen",
    cart_subtotal: "Zwischensumme",
    cart_shipping: "Versand",
    cart_total: "Gesamt",
    cart_checkout: "Zur Zahlung",
    // checkout success
    success_title: "Zahlung erhalten.",
    success_sub: "Danke für Ihre Bestellung. Sie wird innerhalb von 24 Stunden versendet.",
    checking: "Zahlungsstatus wird geprüft…",
    // auth
    auth_login_title: "Anmelden",
    auth_register_title: "Registrieren",
    auth_email: "E-Mail",
    auth_password: "Passwort",
    auth_name: "Name",
    auth_no_account: "Noch kein Konto?",
    auth_have_account: "Bereits ein Konto?",
    auth_register_link: "Registrieren",
    auth_login_link: "Anmelden",
    auth_submit_login: "Anmelden",
    auth_submit_register: "Konto erstellen",
    // account
    account_title: "Mein Konto",
    account_orders: "Bestellungen",
    account_hello: "Willkommen zurück",
    // admin
    admin_title: "Admin",
    admin_products: "Produkte",
    admin_orders: "Bestellungen",
    admin_stats: "Statistik",
    // contact
    contact_title: "Kontakt",
    contact_sent: "Nachricht gesendet. Wir antworten innerhalb von 24 Stunden.",
    // faq
    faq_title: "Häufig gestellte Fragen",
    // disclaimer
    disclaimer_title: "Forschungsdisclaimer",
  },
};

export function useI18n() {
  const lang = (typeof window !== "undefined" && localStorage.getItem("pv_lang")) || "en";
  const t = (k) => dict[lang]?.[k] || dict.en[k] || k;
  const setLang = (l) => {
    localStorage.setItem("pv_lang", l);
    window.dispatchEvent(new Event("pv_lang_change"));
  };
  return { lang, t, setLang };
}
